import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Icon, IconButton, InputAdornment, makeStyles, NativeSelect, TextField, Tooltip} from "@material-ui/core";
import findByString from "../../../../../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import AdaptiveLayoutSetup from "../AdaptiveLayoutSetup";

const useStyles = makeStyles(() => ({
    marginDense: {
        padding: 0,
    },
}));

const DimensionsField = ({setValue, label, name, path, values, disabled}) => {
    const classes = useStyles();
    const [valueType, setValueType] = useState('px');
    const [adaptiveSettingsAnchor, setAdaptiveSettingsAnchor] = useState(null)
    const value = findByString(values, path) || "";
    let isAdaptiveValue = typeof value === 'object';
    let currentValue = isAdaptiveValue ? value.desktop : value;
    //remove all non digit symbols
    const fieldValue = valueType === 'fx' ? currentValue : currentValue.replace(/[^0-9.,]/g, "");

    useEffect(() => {
        //find value, and setValueType(px, %, vh)
        const regex = /^\d+(px|%|vh)$/;

        let findType = currentValue.match(regex);
        let type = findType ? findType[1] : 'fx';
        setValueType(type)
    }, [path]);

    function onChangeValueType({target: {value}}) {
        let currentValue = fieldValue;
        if (value === '%' && fieldValue > 100) {
            currentValue = 100
        }

        if(value === 'fx') {
            setValue(currentValue, path)
            setValueType(value);
            return
        }

        setValueType(value);
        setValue(`${currentValue}${value}`, path)
    }

    function onChangeDimension({target: {value: inputValue}}) {
        if (!inputValue) {
            setValue(isAdaptiveValue ? {...value, desktop: 'auto'} : 'auto', path);
            return
        }
        let currentValue = valueType === 'fx' ? inputValue : `${inputValue}${valueType}`
        setValue(isAdaptiveValue ? {...value, desktop: currentValue} : currentValue, path)
    }

    function onApplyAdaptiveValues(values) {
        let valuesWithTypes = {};
        Object.keys(values).map(value => {
            valuesWithTypes[value] = `${values[value]}${valueType}`
        })
        setValue(valuesWithTypes, path)
    }

    console.log(valueType)
    return (
        <div style={{marginTop: 3, display: 'flex'}}>
            <div style={{width: 100}}>{label}</div>
            <TextField
                style={{width: 226, marginLeft: 2}}
                fullWidth
                disabled={disabled}
                value={fieldValue ? fieldValue : ""}
                className={"form-dynamic"}
                type={valueType === 'fx' ? 'string' : 'number'}
                size={"small"}
                variant={"outlined"}
                onChange={onChangeDimension}
                inputProps={{
                    //min: 0,
                   // max: valueType === '%' ? 100 : 10000
                }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end" style={{margin: 0}} classes={{positionEnd: classes.marginDense}}>
                            <NativeSelect
                                value={valueType}
                                disableUnderline
                                disabled={disabled}
                                style={{background: "#f7f7f7"}}
                                onChange={onChangeValueType}
                            >
                                <option value={'px'}>
                                    px
                                </option>
                                <option value={'%'}>
                                    %
                                </option>
                                {name === 'height' && (
                                    <option value={'vh'}>
                                        vh
                                    </option>
                                )}
                                {(name === 'height' || name === 'width') && (
                                    <option value={'fx'}>
                                        fx
                                    </option>
                                )}

                            </NativeSelect>
                        </InputAdornment>
                    ),
                    startAdornment: (
                        <InputAdornment position={'start'}>
                            <Tooltip title={'Adaptive Settings'}>
                                <IconButton size={"small"}
                                            disabled={disabled}
                                            onClick={(e) => setAdaptiveSettingsAnchor(e.currentTarget)}
                                >
                                    <Icon fontSize={"small"}>
                                        dashboard
                                    </Icon>
                                </IconButton>
                            </Tooltip>
                        </InputAdornment>
                    ),
                    classes: {adornedEnd: classes.marginDense}
                }}
            />
            {adaptiveSettingsAnchor && (
                <AdaptiveLayoutSetup
                    anchor={adaptiveSettingsAnchor}
                    onClose={() => setAdaptiveSettingsAnchor(null)}
                    value={value}
                    apply={onApplyAdaptiveValues}
                />
            )}
        </div>
    )
};

DimensionsField.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string,
    values: PropTypes.object,
    path: PropTypes.string,
    setValue: PropTypes.string
};

export default DimensionsField;